/**
 * This file is part of the MedSafe application which is commercial software created by MedVision360 B.V.
 * The source code is proprietary and confidential.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Copyright (c) by MedVision360 B.V. All rights reserved.
 *
 * For the application name: io.medrecord.medsafe
 */

import { Injectable } from '@angular/core';

@Injectable()
export class AttachmentsService {
  downloadFile(content: string, fileName: string): void {
    const a = document.createElement('a'); // Create <a>
    a.href = content; // Base64 Goes here
    a.download = fileName; // File name Here
    a.click(); // Downloaded file
  }

  openFile(content: string, fileName: string): void {
    const win = window.open();
    win.document.write(
      '<iframe src="' +
        content +
        '" style="border:0; top:0; left:0; bottom:0; right:0; width:100%; height:100%;" allowfullscreen></iframe>'
    );
    win.document.title = fileName;
  }
}
